import * as React from 'react';
import { PasswordResetPage } from '~src/authentication/components/PasswordResetPage';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

export const RequestPasswordResetProvider = (): JSX.Element => {
  return(
    <DefaultServerTitleWrapper>
      <div>
        <PasswordResetPage />
      </div>
    </DefaultServerTitleWrapper>
  );
};
